import React from "react";

import FullStory from "react-fullstory";

// New scrollbar support since v4
import dragscroll from "dragscroll";

import socketIOClient from "socket.io-client";

import {
	turnOffSocketEvents,

	// Socket emitters
	emitGameConnect,
	emitGameDisconnect,
} from "@/modules/sockets";

import {
	isDev,

	historyOnlyGames,

	getWindowOpener,

	fetchGameHistory,
	fetchResultHistory,

	// COMMON M26 FUNCTIONS
	bindLottoFunctions,

	checkController,

	// sanitiseBets,
	applyCommonInsertBet,

	ApplyCommonInsertBetType,

	// Common games
	CheckControllerType,

	isNullOrEmpty,

	//User observer script
	allowObserverScripts,

	devWarnings,
	isMobile
} from "@/modules/commonMobile";

import {
	getBuildDateStr,
	productName,
	versionStr,
} from "@/modules/versionInfo";

import {
	updateLanguage,
} from "@/modules/locales";

import {
	fetchNews
} from "@/modules/news";

import {
	fetchTransactionHistory,
	toggleTransactionDetail,
	defaultTransactionHistoryState
} from "@/modules/transactions";

// MACHINE GAME MODULE IMPORTS
import {
	addNumberM26NotDom, // for keydown
	AddNumberNotDomType
} from "@/modules/games/LottoGame";

import {
	addNumberM30NotDom, // for keydown
} from "@/modules/games/5D";

// Common sound module
import {
	importCommonSFX,
	importCommonBGM,
	bindCommonSounds,

	importBaccaratVoiceFiles,
	importDragonTigerVoiceFiles,

	IAudioFiles,
	IAudioMethods,
} from "@/modules/sounds";

import {
	activateGameGroup,
	bindCommonGameGroupingFunctions
} from "@/modules/gameGrouping";

import {
	clearModals
} from "@/modules/modals";

// import {
// 	newGetPcodeTest,
// 	getGameCodeTest
// } from "@/modules/testUnits";



/* Common CSS imports */
import "@/assets/fonts/sl-fonts/style.css";
import "@/index.scss";
import "@/scrollbars.scss";

import "../../modals.scss";

import "../MaximizeGame/index.scss";
import "../MaximizeMachineGame/index.scss";

import "../MaximizeGameV2/index.scss";
import "../MaximizeGameV2/dark.scss";

import "../MaximizeGameV4/index.scss";
import "../MaximizeGameV4/dark.scss";

import "../GameStatistics/gameStatistics.scss";

// import "simplebar/dist/simplebar.scss";


/* How to Play CSS */
import "../HowToPlayPages/howToPlay.scss";

/* Component imports */
import DesktopHeader from "../DesktopHeader";
import ErrorPage from "../ErrorPage";
import SettingsForm from "../Settings";

// Dealing Result Text-to-Speech
import TTS from "../TTS";

// Detects if the user uses a mobile device
import MobileDetect from "mobile-detect";

import {
	IGameType,
	IBaccaratVoiceSets,
	IUserdataType,
} from "@/types/GlobalTypes";

import { isIPad, isIPadOS } from "@/modules/iOSDetection";
import { mainGameCheckTimeout } from "@/modules/timeouts";
import { sharedGameWrapperState, IDesktopState } from "@/modules/sharedState";
import { updateSettings, defaultSettingsState } from "@/modules/settings";
import { redirectToPhaserGame } from "@/modules/phaserGames";
import { getBasePcode, isV2Game, isV4Game, newGetPcode, totoGames } from "@/modules/gamePcode";
import { changeVideoQuality, getStreamingLink, hasHDStreaming, updateVideoQuality } from "@/modules/videoQuality";
import { toggleHowToPlay } from "@/modules/howToPlay";
import { goToOperatorLobby, closeAllGames, closeGame, removeWin, removeWins, toggleGameStatistics, toggleInfoNews, toggleLobbyHistory, toggleLobbyMinMax, toggleLobbyRoadmap, togglePopupResultHistory, togglePopupTransactionHistory, toggleTooltipSettings, updateGameTimers } from "./methods";
import { allTableActivatorFragment, bannerFragment, gameGroupFragment, howToPlayPopupFragment, infoNewsFragment, lobbyCategoryFragment, lobbyFooterFragment, lobbyGameListFragment, resultHistoryPopupFragment, transactionHistoryPopupFragment } from "./fragments";
import { setLobbyRoadmapFilter, toggleFavourite } from "@/modules/onlyLobbyMethods";
import { fetchGameList, fetchGameTime, fetchSoundVolumes, fetchUserData } from "./fetchMethods";
import lobbyKeyDownHandler from "./keyDownHandler";
import gameFragment from "./gameFragment";
import { changeChip, clearInvalidBets, clickClear, clickRebet, clickSubmit, clickUndo, insertBet } from "./bettingMethods";
import { applyGameResult, closeTimer, initSocketIO, loadNewValue } from "./socketMethods";
import { addNumberM42NotDom } from "@/modules/games/Pinball";
/* End of Component Imports */

// export default is moved to the bottom
interface Desktop extends IAudioFiles, IAudioMethods { }

/**
 * Mix of Lobby & Game Renderer
 */
class Desktop extends React.Component<null, IDesktopState> {
	// For Debugging
	enableGuidelines = false;
	glow = false;

	socketio: typeof socketIOClient;
	hasEmittedLobbyConnect = false;

	checkController: CheckControllerType;

	hasLoadedCommonSounds = false;

	// For BC and DT voice file imports and TTS in renderGame()
	// helps performance on first time load
	loadedVoiceFiles: string[] = [];


	// Game-related types
	addedTimers: boolean;

	startingWindowSize = { w: window.outerWidth, h: window.outerHeight };

	defaultHowToPlayPcode: string;

	// Settings
	private updateSettings = updateSettings;

	private updateLanguage = updateLanguage;

	// Function Bindings
	applyCommonInsertBet: ApplyCommonInsertBetType;

	// News
	fetchNews = fetchNews;

	// Gong Ball
	lastBankerMatch: number;
	lastPlayerMatch: number;

	//Baccarat
	baccaratVoiceSets: IBaccaratVoiceSets;

	fetchResultHistory = fetchResultHistory.bind(this);
	fetchGameHistory = fetchGameHistory;
	fetchTransactionHistory = fetchTransactionHistory.bind(this);
	toggleTransactionDetail = toggleTransactionDetail.bind(this);

	//for how to play (?)
	activePcode: string;

	allowRefetchTransaction: boolean;

	// Machine games
	addNumberM26NotDom: AddNumberNotDomType;
	addNumberM30NotDom: AddNumberNotDomType;
	addNumberM42NotDom: AddNumberNotDomType;

	setLobbyGameFilter: () => void;

	hasLoadedMainGame: boolean;
	intervalRenderMainGame: number;

	intervalGame: number;
	intervalUserData: number;
	intervalGameTime: number;

	applyRoadmapAttempts: number;
	applyRoadmapTimer: number;

	timeoutWin: number;
	timerTimer: number;
	timeoutWindowSize: number;

	playCountdownSFX: () => void;
	playCloseBetSFX: () => void;

	baccaratTimeout: number;
	playPlayerVoiceTimeout: number;
	playBankerVoiceTimeout: number;

	dragonTigerTimeout: number;
	playResultTimeout: number;

	playCardOpenSFX: () => void;
	playWinVoice: (arg0: string) => void;
	playTieVoice: (arg0: string) => void;

	toggleShowGameGroup: () => void;


	// for V2 Games (with scanner) & also machine games
	// setter: fetchGameList()
	// usage: socket events
	prevScanValue: { [pcode: string]: any } = {}


	constructor(props: any) {
		super(props);


		// console.log(props);
		this.checkMobileRedirection();

		// Insert unit tests here
		// if (isDev()) {
		// 	newGetPcodeTest();
		// 	getGameCodeTest();
		// 	newSamGongResultComparisonTest();
		// }

		// Note: Sound imports are moved into renderGame

		// Note: Import Baccarat and DT voice files are moved into renderGame

		this.checkController = checkController;

		// Only for m26
		bindLottoFunctions(this);

		// Only for lobby game grouping
		bindCommonGameGroupingFunctions(this);

		this.applyCommonInsertBet = applyCommonInsertBet.bind(this);

		this.addNumberM26NotDom = addNumberM26NotDom.bind(this);
		this.addNumberM30NotDom = addNumberM30NotDom.bind(this);
		this.addNumberM42NotDom = addNumberM42NotDom.bind(this);

		this.toggleShowGameGroup = this.toggleShowGameGroup.bind(this);

		this.baccaratVoiceSets = {};

		this.state = {
			...sharedGameWrapperState,

			// Game list and favourited pcodes
			games: null,
			timers: null,
			userdata: null,
			lang: null,

			// Lobby only
			activeGameGroup: null,
			showLobbyGameGroup: false,

			uniqueGamePcodes: null,
			gameGroups: null,
			fastTableGames: null,

			// Temporary game state
			activeGame: null,

			// Check fetchFavourites()
			// Check toggleFavourite(e: attribute pcode) to set
			favouritedGames: [],

			// To help manage minimised and maximised games
			maximisedGamePcode: "",
			activeGameCount: 0, // useful to count collection of active games
			activeGamePcodes: [], // useful to track maximising and restoring

			// to check fullscreen
			isFullscreen: false,
			allowFullscreen: !!getWindowOpener() || isDev(),

			// to check maingame just once
			hasLoadedMainGame: false,

			// in Lobby: enables game logo animation and shows Play Now button
			activeHover: "",

			// How to Play component
			showHowToPlay: false,
			showHowToPlayDropdown: false,
			howToPlayPcode: null,
			howToPlayGamePcode: null,

			// Result History component
			showResultHistory: false,
			gameResultHistoryPage: 0,
			showGameResultHistoryLoadingOverlay: false,

			// Filters games
			lobbyGameFilter: "all",

			// Show all history
			showLobbyHistory: false,
			showLobbyRoadmap: true,

			...defaultTransactionHistoryState,

			// News Popup component
			showInfoNews: false,
			news: null,

			// When there's a connection problem, just set this to active
			showErrorPage: false,
			// Error State
			errorType: null,
			errorMessage: null,

			// Applying default settings
			isLoadingStreaming: true,

			// Settings Popup
			showSettingsPopup: false,
			defaultEnableStreaming: false,

			...defaultSettingsState,

			// For Baccarat and Dragon & Tiger
			completeTable: false,
			baccaratDarkMode: false,

			// For Hidden Roadmap (m25)
			showHiddenRoadmap: false,

			// For RaceBall (m26)
			activeTicketIndexM26: -1,

			/**
			 * Automatically hides header when active
			 * Setter: Header
			 */
			autoHideHeader: false,

			// Mandatory for PopupResultHistory
			portraitTabIndex: 0,

			// Insufficient balance indicator
			insufficientBalance: false,

			activeVideoQuality: "sd",
		};

		// start of SocketIO
		const lobby = this;

		window.addEventListener("keydown", event => {
			lobby.lobbyKeyDownHandler(event);
		});

		window.addEventListener("mousedown", () => {
			if (!lobby.hasLoadedCommonSounds)
				return;

			if (lobby.playClickSFX)
				lobby.playClickSFX();

			// Checks first click to start playing the BGM
			if (!lobby.playedBGM) {
				if (lobby.state.userdata.user.enableMusic) {
					lobby.playBGM();
					lobby.playedBGM = true;
				}
			}
		});
	} // end of constructor

	lobbyKeyDownHandler = lobbyKeyDownHandler;

	componentDidUpdate() {
		window.setTimeout(() => {
			// Enables drag & scroll
			dragscroll.reset();
		}, 250);
	}

	/**
	 * Automatically scale single game (V1)
	 * @returns 
	 */
	updateDimensions() {
		if (!this.state.games)
			return;

		for (const pcode in this.state.games) {
			if (!this.state.games[pcode])
				return;

			const gameNode = document.querySelector(`[data-pcode="${pcode}"]`);

			if (!gameNode)
				continue;

			gameNode.removeAttribute("style");

			if (this.state.games[pcode].maximised) {
				if (!gameNode)
					return;

				const scale = Math.min(window.innerWidth * 0.8 / gameNode.clientWidth,
					window.innerHeight * 0.8 / gameNode.clientHeight);

				const translateY = -(1 - scale) * 50;

				const v2v4 = isV2Game(pcode) ||
					isV4Game(pcode);

				//Resize games if they're not V2 nor V4 games
				if (!v2v4)
					gameNode.setAttribute(
						"style",
						`position: absolute; transform: translate(-50%, ${translateY}%) scale(${scale}); left: 50%;`
					);
			}
		}
	}

	componentDidMount() {
		devWarnings(this);

		window.addEventListener("resize", this.updateDimensions.bind(this));

		this.fetchGameList({ firstTime: true });
		this.fetchNews();
		this.fetchUserData({ firstTime: true });
	}

	// Checks user data then redirects to phone
	checkMobileRedirection() {
		const lobby = this;

		// const md = new MobileDetect(window.navigator.userAgent);

		if (isMobile() && !isIPad()) {
			window.setTimeout(() => {
				const { userdata } = lobby.state;

				if (isNullOrEmpty(userdata))
					return;

				const { origin } = window.location;
				const { maingame, operatorId } = userdata.user;

				// Todo: make a getter function to get the absolute URL to the game's index.html file

				if (!isNullOrEmpty(maingame)) {
					if (maingame === "baccarat-lobby")
						window.location.assign(origin + "/m/baccarat");
					else {
						const pcode = newGetPcode(maingame);

						redirectToPhaserGame(pcode, operatorId);

						window.location.assign(
							// hasPhaserGame(pcode)
							// ? `${origin}/${getPhaserGameDir(pcode)}/index.html`
							// :
							`${origin}/play/${maingame}`
						);
					}
				} else window.location.assign(window.location.origin + "/m");
			}, mainGameCheckTimeout);
		}
	}

	// methods.ts
	removeWin = removeWin;
	removeWins = removeWins;
	updateGameTimers = updateGameTimers;

	// fetchMethods.ts
	fetchGameList = fetchGameList;
	fetchGameTime = fetchGameTime;
	fetchSoundVolumes = fetchSoundVolumes;
	fetchUserData = fetchUserData;

	// socketMethods.ts
	applyGameResult = applyGameResult;
	closeTimer = closeTimer;
	initSocketIO = initSocketIO;
	loadNewValue = loadNewValue;

	attemptRenderMainGame(userdata: IUserdataType, renderAttempts: number) {
		console.log("Attempting render " + renderAttempts);
		console.log("userdata " + JSON.stringify(userdata)); 
		// console.log("this.state " + JSON.stringify(this.state)); 

		const {
			games,
			timers
		} = this.state;

		const gameCount = Object.keys(games).length;
		const timerCount = Object.keys(timers).length;

		if (games &&
			gameCount > 0 &&
			timers &&
			timerCount > 0) {

			// Activate game group popup on Lobby
			const { maingame } = userdata.user;

			const isLobbyOrPopup = ["lobby", "popup"].some(word =>
				maingame.includes(word)
			);

			if (isLobbyOrPopup) {
				// Game popup trigger format:
				//   "lobby-roulette"
				//   or
				//   "popup-roulette"
				// Where "roulette" is the grouped game name
				const maingameName = maingame.split("-")[1]
				const popupPcode = maingameName === "idnlotto" ? totoGames[0] : newGetPcode(maingameName);

				//To debug popupPcode:
				// console.log("hLMG", maingame, popupPcode);

				if (popupPcode) {
					// Same as activateGameGroup
					this.setState({
						showLobbyGameGroup: true,
						activeGameGroup: popupPcode
					});
				}
			} else {
				// Starts game as usual if it is a valid game name
				const pcode = newGetPcode(userdata.user.maingame);

				if (pcode) {
					this.renderGame({ pcode: pcode });

					// Automatically sizes active game window, in case renderGame fails
					this.setWindowSize(1500);
				}
			}

			// Clears polling interval
			window.clearInterval(this.intervalRenderMainGame);
		} else {
			renderAttempts++;

			if (renderAttempts > 20) {
				window.clearInterval(this.intervalRenderMainGame);
				console.error("Timeout exceeds 60000 milliseconds");
				this.setState({ showErrorPage: true, errorType: "lostauth", errorMessage: "" });
			}
		}

		return renderAttempts;
	}

	componentWillUnmount() {
		// Todo: unbind keydown and mousedown

		turnOffSocketEvents(this.socketio);

		delete this.socketio;

		clearInterval(this.intervalGame);
		clearInterval(this.intervalUserData);
	}


	// bettingMethods.ts
	changeChip = changeChip;
	clearInvalidBets = clearInvalidBets;
	clickClear = clickClear;
	clickRebet = clickRebet;
	clickSubmit = clickSubmit;
	clickUndo = clickUndo;
	insertBet = insertBet;

	maximiseGame(e: React.MouseEvent) {
		const pcode = e.currentTarget.getAttribute("pcode");

		const activeGamePcodes = this.state.activeGamePcodes || [];

		for (const _pcode in this.state.games) {
			const game = this.state.games[_pcode];

			if (game.active &&
				!activeGamePcodes.includes(_pcode))
				activeGamePcodes.push(_pcode);
		}

		// console.log("mG aGP", activeGamePcodes);

		this.setState({ activeGamePcodes });
		this.closeAllGames();
		this.renderGame({ pcode: pcode });

		// console.log("mG pcode", pcode);
	}

	restoreGames() {
		const maximisedGamePcode = this.state.maximisedGamePcode;

		window.setTimeout(() => {
			this.state.activeGamePcodes
				.filter(item => item !== maximisedGamePcode)
				.forEach(item => {
					this.renderGame({ pcode: item });
				});
		}, 50);
	}

	/**
	 * Shows play button on <LobbyGame> hover
	 * @param e 
	 */
	private showPlayButton(e: React.MouseEvent) {
		this.setState({ activeHover: e.currentTarget.getAttribute("pcode") });
	}

	/**
	 * Hides play button on <LobbyGame> leave
	 */
	private hidePlayButton() {
		this.setState({ activeHover: null });
	}

	private reloadStreaming() {
		const enableStreaming = !!this.state.enableStreaming;
		const lobby = this;
		const {
			activeVideoQuality,
			games
		} = this.state;

		for (const pcode in games) {
			const game = games[pcode];
			delete game.streamObj;

			const streamingLink = getStreamingLink(game, activeVideoQuality);

			game.streamObj = (
				<object data={streamingLink + "&a=" + Math.random()}>
					GAME STREAM
				</object>
			);
		}

		this.setState({
			games,
			enableStreaming: false,
			isLoadingStreaming: true,
		});

		window.setTimeout(() => {
			if (enableStreaming)
				lobby.setState({ enableStreaming: true });
		}, 800);

		window.setTimeout(() => {
			if (enableStreaming)
				lobby.setState({ isLoadingStreaming: false });
		}, 3000);
	}

	/**
	 * Used in renderGame()
	 */
	private attemptLoadTTS(game: IGameType) {
		const { pcode } = game;
		const basePcode = getBasePcode(game.pcode);

		// Only load BC and DT voice files on first render
		const voiceHasLoaded = this.loadedVoiceFiles.includes(pcode);

		if (voiceHasLoaded)
			return;

		if (["m22", "m28", "m38"].includes(basePcode))
			importBaccaratVoiceFiles(this);
		else if (basePcode === "m23")
			importDragonTigerVoiceFiles(this);

		game.tts = new TTS(basePcode);

		this.loadedVoiceFiles.push(pcode);
	}

	private recountActiveGame() {
		const {
			games
		} = this.state;

		// Find maximised game's pcode
		let activeGameCount = 0,
			maximisedGamePcode = null;
		for (const pcode in games) {
			const game = games[pcode];

			if (game.maximised) {
				const isHistoryOnlyGame = historyOnlyGames.includes(pcode);

				// prevents lobbyRoadmap & lobbyHistory from being active together
				game.lobbyRoadmap = !isHistoryOnlyGame;

				// Shows history on m7 (Oglok) by default
				game.lobbyHistory = isHistoryOnlyGame;
				game.lobbyMinMax = false;
			}

			if (game.active) {
				game.maximised = false;
				activeGameCount++;
				maximisedGamePcode = pcode;
			}
		}

		if (activeGameCount === 1) {
			const maximisedGame = games[maximisedGamePcode];

			maximisedGame.maximised = true;
			maximisedGame.lobbyHistory = true;
			maximisedGame.lobbyStatistics = false;
		} else if (activeGameCount === 0)
			this.closeAllGames(); // resets all display parameters

		this.setState({
			activeGameCount,
			maximisedGamePcode
		});
	}

	bindCommonSounds = bindCommonSounds;

	get gameCount() {
		const { games } = this.state;
		return Object.keys(games ?? {}).length;
	}

	/**
	 * Used in renderGame()
	 */
	private loadCommonSounds() {
		if (this.hasLoadedCommonSounds)
			return;

		// check commonSounds.js for additional functions and mp3 files
		importCommonSFX(this);
		importCommonBGM(this);
		this.bindCommonSounds();

		this.bgmLobby.volume = this.state.musicVolume / 100;

		this.hasLoadedCommonSounds = true;
	}

	private startAllGames() {
		const {games, userdata} = this.state;

		for (const pcode in games) {
			const game = games[pcode];
			game.active = true;

			if (isV2Game(pcode))
				game.lobbyRoadmap = true;

			if (game.isGameConnected)
				emitGameDisconnect(this, userdata, game);
		}

		this.setState({
			activeGameCount: this.gameCount,
			games
		});
	}

	// renderGame()
	/**
	 * @summary Opens game when the user clicks "Play" button in the Lobby.
	 * @param e 
	 */
	// React.MouseEvent & {special: string, pcode: string}
	protected renderGame(e: any) {
		const { games, userdata } = this.state;

		this.loadCommonSounds();

		if (this.state.defaultEnableStreaming)
			this.reloadStreaming();

		if (e.special === "all_games") {
			this.startAllGames();
			return;
		}

		const pcode = e.pcode || e.currentTarget.getAttribute("game");
		const game = games[pcode];

		if (!game) {
			console.error(`games[${pcode}] is undefined`);
			return;
		}

		redirectToPhaserGame(pcode, userdata.user.operatorId);

		this.attemptLoadTTS(game);

		game.active = !game.active;

		this.recountActiveGame();

		if (isV2Game(pcode)) {
			// Disables roadmap & history on m22
			game.lobbyRoadmap = true;
			game.lobbyHistory = false;
			game.lobbyMinMax = false;
		}

		// Emits gameConnect
		if (!game.isGameConnected)
			emitGameConnect(this, userdata, game);

		// Enables rebet control
		this.checkController(game); // renderGame

		this.setState({
			// Hide settings and game group popup
			showLobbyGameGroup: false,
			games,
		}, () => {
			this.setWindowSize(33);
		}); // renderGame
	}

	/**
	 * Resize single game automatically
	 */
	private setWindowSize(delay: number) {
		const lobby = this;

		this.timeoutWindowSize = window.setTimeout(() => {
			lobby.updateDimensions();
		}, delay || 200);
	}

	clearModalsWithPcode(e: React.MouseEvent) {
		const pcode = e.currentTarget.getAttribute("pcode");
		const { games } = this.state;
		clearModals(games[pcode]);
		this.setState({ games });
	}

	toggleDarkMode() {
		this.setState({
			baccaratDarkMode: !this.state.baccaratDarkMode
		});
	}

	toggleCompleteTable() {
		console.log("last tCT(): " + this.state.completeTable);

		this.setState({
			completeTable: !this.state.completeTable
		});
	}

	toggleHiddenRoadmap() {
		this.setState({ showHiddenRoadmap: !this.state.showHiddenRoadmap });
	}

	toggleEnlargeRoadmap(e: React.MouseEvent) {
		const { games } = this.state,
			pcode = e.currentTarget.getAttribute("pcode"),
			prop = e.currentTarget.getAttribute("prop"),
			game = games[pcode];

		if (!game.enlargedRoadmap)
			game.enlargedRoadmap = prop;
		else delete game.enlargedRoadmap;

		this.setState({ games });
	}

	get isStatePreparation() {
		const { games, timers, userdata, lang } = this.state;
		return [games, timers, userdata, lang].some(item => !item);
	}

	get devMessageComponent() {
		const isDevClass = isDev()
			? " dev"
			: "";

		const { games, timers, userdata, lang } = this.state;

		return (
			<div className={"fullscreen-message" + isDevClass}>
				{
					!games
						? <div>Loading games...</div>
						: null
				}
				{
					!timers
						? <div>Loading timers...</div>
						: null
				}
				{
					!userdata
						? <div>Loading user data...</div>
						: null
				}
				{
					!lang
						? <div>Loading language data...</div>
						: null
				}
			</div>
		);
	}

	get v1Props() {
		// Todo: combine the same props
		// Todo: bind common functions
		const {
			userdata,
			activeGameCount,
			enableStreaming,
			isLoadingStreaming,
			lang,
			activeGamePcodes,
			activeVideoQuality: videoQuality,
			completeTable
		} = this.state,
			{ chipBase } = userdata.user;

		return (
			{
				userdata,
				activeGameCount,

				// for Duel Dice (m39)
				completeTable,
				toggleCompleteTable: this.toggleCompleteTable.bind(this),

				// Betting functions
				closeGame: this.closeGame.bind(this),
				clearBet: this.clickClear.bind(this),
				undoBet: this.clickUndo.bind(this),
				reBet: this.clickRebet.bind(this),
				sendBet: this.clickSubmit.bind(this),
				insertBet: this.insertBet.bind(this),

				clearModalsWithPcode: this.clearModalsWithPcode.bind(this),

				// Roadmap and History
				setLobbyRoadmapFilter: setLobbyRoadmapFilter.bind(this),
				toggleLobbyRoadmap: this.toggleLobbyRoadmap.bind(this),
				toggleLobbyHistory: this.toggleLobbyHistory.bind(this),
				toggleLobbyMinMax: this.toggleLobbyMinMax.bind(this),
				toggleGameStatistics: this.toggleGameStatistics.bind(this),

				chipBase,

				// for streaming
				enableStreaming,
				isLoadingStreaming,

				// for multi-language support
				lang,

				// for maximising game
				activeGamePcodes,
				maximiseGame: this.maximiseGame.bind(this),
				restoreGames: this.restoreGames.bind(this),

				// video quality support
				videoQuality,
				changeVideoQuality: changeVideoQuality.bind(this)
			}
		);
	}

	get v2v4Props() {
		const {
			userdata,
			lang,
			activeGameCount,
			autoHideHeader
		} = this.state;

		const {
			chipBase
		} = this.state.userdata.user;

		return (
			{
				userdata,
				activeGameCount,

				// Betting functions
				closeGame: this.closeGame.bind(this),
				clearBet: this.clickClear.bind(this),
				undoBet: this.clickUndo.bind(this),
				reBet: this.clickRebet.bind(this),
				sendBet: this.clickSubmit.bind(this),
				insertBet: this.insertBet.bind(this),

				clearModalsWithPcode: this.clearModalsWithPcode.bind(this),

				// Roadmap and History
				setLobbyRoadmapFilter: setLobbyRoadmapFilter.bind(this),
				toggleLobbyRoadmap: this.toggleLobbyRoadmap.bind(this),
				toggleLobbyHistory: this.toggleLobbyHistory.bind(this),
				toggleLobbyMinMax: this.toggleLobbyMinMax.bind(this),
				toggleGameStatistics: this.toggleGameStatistics.bind(this),

				chipBase,

				updateSettings: this.updateSettings.bind(this),

				// for streaming
				enableStreaming: this.state.enableStreaming,
				isLoadingStreaming: this.state.isLoadingStreaming,

				// for multi-language support
				lang,

				completeTable: this.state.completeTable,
				toggleCompleteTable: this.toggleCompleteTable.bind(this),

				baccaratDarkMode: this.state.baccaratDarkMode,
				toggleDarkMode: this.toggleDarkMode.bind(this),

				// For enlarge buttons
				toggleEnlargeRoadmap: this.toggleEnlargeRoadmap.bind(this),

				// for maximising game
				maximiseGame: this.maximiseGame.bind(this),
				restoreGames: this.restoreGames.bind(this),

				videoQuality: this.state.activeVideoQuality,
				changeVideoQuality: changeVideoQuality.bind(this),

				autoHideHeader
			}
		);
	}

	get totoProps() {
		const {
			lang,
			activeGameCount,
			activeGamePcodes,
			userdata
		} = this.state;

		return (
			{
				userdata,
				lang,
				maximiseGame: this.maximiseGame.bind(this),
				activeGameCount,
				activeGamePcodes,
				restoreGames: this.restoreGames.bind(this),
				closeGame: this.closeGame.bind(this)
			}
		);
	}

	get noActiveGame() {
		return this.state.activeGameCount === 0;
	}

	get hasActiveGame() {
		return this.state.activeGameCount > 0;
	}

	// fragments.tsx
	lobbyCategoryFragment = lobbyCategoryFragment;
	bannerFragment = bannerFragment;
	lobbyGameListFragment = lobbyGameListFragment;
	transactionHistoryPopupFragment = transactionHistoryPopupFragment;
	resultHistoryPopupFragment = resultHistoryPopupFragment;
	infoNewsFragment = infoNewsFragment;
	howToPlayPopupFragment = howToPlayPopupFragment;
	lobbyFooterFragment = lobbyFooterFragment;

	// gameFragment.tsx
	gameFragment = gameFragment;

	setAutoHideHeader(value: boolean) {
		console.log("sAHH call ", value);

		this.setState({
			autoHideHeader: value
		});
	}

	headerFragment() {
		const {
			userdata,
			lang: langdata,
			maximisedGamePcode: pcodeMax,
			// gameGroups
		} = this.state,
			langStr = userdata.user.lang;

		return (
			<DesktopHeader
				{...{
					langdata,
					langStr,
					pcodeMax,
					// gameGroups,
					...this.state
				}}

				renderGame={this.renderGame.bind(this)}

				closeAllGames={this.closeAllGames.bind(this)}
				goToOperatorLobby={this.goToOperatorLobby.bind(this)}
				toggleHowToPlay={toggleHowToPlay.bind(this)}

				togglePopupTransactionHistory={this.togglePopupTransactionHistory.bind(this)}
				togglePopupResultHistory={this.togglePopupResultHistory.bind(this)}

				updateLanguage={this.updateLanguage.bind(this)}
				updateUserData={this.fetchUserData.bind(this)}

				setAutoHideHeader={(value: boolean) => this.setAutoHideHeader(value)}
			/>
		)
	}

	settingsFragment() {
		if (!this.state.showSettingsPopup)
			return null;

		const {
			lang: langdata,
			activeVideoQuality: videoQuality,
			games,
			maximisedGamePcode,
		} = this.state,
			game = games[maximisedGamePcode],
			langStr = this.state.userdata.user.lang;

		return (
			<>
				<div key="sSP_overlay" className="overlay transparent"
					onClick={this.toggleTooltipSettings.bind(this)} />,

				<SettingsForm
					key="sSP_form"

					{...{
						langdata,
						langStr,
						videoQuality,
						...this.state
					}}

					toggleTooltipSettings={this.toggleTooltipSettings.bind(this)}
					showStreamingQuality={hasHDStreaming(game)}
					updateSettings={this.updateSettings.bind(this)}
					updateLanguage={this.updateLanguage.bind(this)}
					updateVideoQuality={updateVideoQuality.bind(this)}
				/>
			</>
		);
	}

	allTableActivatorFragment = allTableActivatorFragment;
	gameGroupFragment = gameGroupFragment;

	protected get commonLobbyGameProps() {
		const {
			timers, lang, games, activeHover, favouritedGames
		} = this.state;

		return (
			{
				timers,
				langdata: lang,
				games,

				activateGameGroup: activateGameGroup.bind(this),

				activeHover,
				favouritedGames,

				// Function bindings
				mouseLeave: this.hidePlayButton.bind(this),
				mouseEnter: this.showPlayButton.bind(this),

				toggleLobbyRoadmap: this.toggleLobbyRoadmap.bind(this),
				toggleLobbyHistory: this.toggleLobbyHistory.bind(this),
				setLobbyRoadmapFilter: setLobbyRoadmapFilter.bind(this),
				renderGame: this.renderGame.bind(this),

				toggleFavourite: toggleFavourite.bind(this),
				toggleHowToPlay: toggleHowToPlay.bind(this),
			}
		);
	}

	versionInfoFragment() {
		return (
			<div className="version-info">
				{productName} Version {versionStr}<br />
				{
					isDev() ?
						`Build date: ${getBuildDateStr()}`
						: null
				}
			</div>
		);
	}

	// Todo: refactor this
	uiFragment() {
		const
			{ device } = this.state.userdata.user,
			desktop = device === "desktop",
			ipad = isIPad() || isIPadOS();

		if (!desktop && !ipad)
			return (
				<div>
					Unknown device detected: {device}
				</div>
			);

		return (
			<div className={
				//Note: write mods here
				(this.enableGuidelines ? "guidelines" : "")
			}>
				{this.headerFragment()}
				{this.bannerFragment()}
				{this.lobbyCategoryFragment()}

				{
					this.noActiveGame
						? this.lobbyGameListFragment()
						: this.gameFragment()
				}

				{this.lobbyFooterFragment()}
				{this.howToPlayPopupFragment()}
				{this.settingsFragment()}
				{this.versionInfoFragment()}
			</div>
		);
	}

	/**
	 * Main render function
	 */
	render() {
		if (this.isStatePreparation)
			return this.devMessageComponent;

		if (this.state.showErrorPage)
			return (
				<ErrorPage
					errorType={this.state.errorType}
					errorMessage={this.state.errorMessage} />
			);

		return (
			<div className={isIPad() || isIPadOS() ? "FullScreen desktop ipad" : "FullScreen desktop"}>
				{
					allowObserverScripts(this.state.userdata) ?
						<FullStory
							debug={false}
							host="fullstory.com"
							namespace="FS"
							org="SCWSS"
						/> : null
				}

				{this.uiFragment()}
			</div>
		);
	} // end of render()

	// methods.ts
	closeGame = closeGame;
	closeAllGames = closeAllGames;
	goToOperatorLobby = goToOperatorLobby;
	toggleInfoNews = toggleInfoNews;
	toggleTooltipSettings = toggleTooltipSettings;
	togglePopupTransactionHistory = togglePopupTransactionHistory;
	togglePopupResultHistory = togglePopupResultHistory;
	toggleLobbyRoadmap = toggleLobbyRoadmap;
	toggleLobbyHistory = toggleLobbyHistory;
	toggleGameStatistics = toggleGameStatistics;
	toggleLobbyMinMax = toggleLobbyMinMax;
}

export default Desktop;